import { queryOptions } from "@tanstack/react-query";

import { authFetch } from "@/lib/api-client";

export interface ScriptDeliveryClientRow {
  tenantId: string;
  name: string;
  delivered: number;
  target: number | null;
  percent: number | null;
  submittedForFinalApproval: number;
}

export interface ScriptDeliverySummary {
  year: number;
  month: number;
  delivered: number;
  target: number;
  percent: number | null;
  submittedForFinalApproval: number;
  clients: ScriptDeliveryClientRow[];
}

export const scriptDeliveryKeys = {
  all: ["script-delivery"] as const,
  summary: () => [...scriptDeliveryKeys.all, "summary"] as const,
};

export function scriptDeliverySummaryQueryOptions() {
  return queryOptions({
    queryKey: scriptDeliveryKeys.summary(),
    staleTime: 0,
    refetchOnWindowFocus: true,
    queryFn: async (): Promise<ScriptDeliverySummary> => {
      const { data } = await authFetch<ScriptDeliverySummary>("/script-delivery/summary");
      return data;
    },
  });
}

export async function saveScriptDeliveryTarget(
  tenantId: string,
  target: number | null,
): Promise<ScriptDeliverySummary> {
  const { data } = await authFetch<ScriptDeliverySummary>(
    `/script-delivery/targets/${encodeURIComponent(tenantId)}`,
    {
      method: "PUT",
      body: JSON.stringify({ target }),
    },
  );
  return data;
}
